/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Guidance_Hardware_3Inputs */

const en_svr_guidance_hardware_3 = /** @type {(inputs: Svr_Guidance_Hardware_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Did you take a photo of the faulty device serial number? (Attach later.)`)
};

const ja_svr_guidance_hardware_3 = /** @type {(inputs: Svr_Guidance_Hardware_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`故障デバイスのシリアル番号の写真を撮りましたか？（後で添付。）`)
};

const fr_svr_guidance_hardware_3 = /** @type {(inputs: Svr_Guidance_Hardware_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avez-vous pris une photo du numéro de série de l'appareil défectueux ? (À joindre plus tard.)`)
};

const de_svr_guidance_hardware_3 = /** @type {(inputs: Svr_Guidance_Hardware_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haben Sie ein Foto der Seriennummer des defekten Geräts gemacht? (Später anhängen.)`)
};

/**
* | output |
* | --- |
* | "Did you take a photo of the faulty device serial number? (Attach later.)" |
*
* @param {Svr_Guidance_Hardware_3Inputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_guidance_hardware_3 = /** @type {((inputs?: Svr_Guidance_Hardware_3Inputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Guidance_Hardware_3Inputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_guidance_hardware_3(inputs)
	if (locale === "ja") return ja_svr_guidance_hardware_3(inputs)
	if (locale === "fr") return fr_svr_guidance_hardware_3(inputs)
	return de_svr_guidance_hardware_3(inputs)
});